import { render } from "./ObjectSystemContacts.vue?vue&type=template&id=37bf0481&scoped=true&ts=true"
import script from "./ObjectSystemContacts.vue?vue&type=script&lang=ts"
export * from "./ObjectSystemContacts.vue?vue&type=script&lang=ts"

import "./ObjectSystemContacts.vue?vue&type=style&index=0&id=37bf0481&scoped=true&lang=css"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bf0481"]])

export default __exports__